module.exports = __webpack_public_path__ + "img/Hotmart-11-pt.b31e7f1a.png";